//ToDo:
//Split & migrate to smaller function based files.

//-------------- utils.js
const debounceWhileSaving = (func, wait, immediate) => {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

const formatDate = (date) => {
    const pad = (num) => num < 10 ? '0' + num : num;
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const escapeHTML = (str) => {
    return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

const extractIsoDateFromText = (text) => {
    const str = String(text || '').trim();
    const match = str.match(/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2}))/);
    return match ? match[1] : null;
}

const hideValidatorToolbox = (shouldShow) => {
    if (shouldShow != undefined) {
        $('#validator-toolbox').addClass('hidden');
    } else {
        if ($('#validator-toolbox').hasClass('hidden')) {
            $('#validator-toolbox').removeClass('hidden');
            localStorage.setItem(gon.user + '_validator-toolbox', 'shown');
        } else {
            $('#validator-toolbox').addClass('hidden');
            localStorage.setItem(gon.user + '_validator-toolbox', 'hidden');
        }
    }
}

//-------------- exif_age_badge.js:

const formatDurationFromDays = (totalDays, format = ['y','m','d','h']) => {

    if (!isFinite(totalDays) || totalDays <= 0) {
        const unit = format[format.length - 1] || 'd';
        return `0${unit}`;
    }

    let totalHours = totalDays * 24;

    if (format.length === 1) {
        const unit = format[0];
        if (unit === 'd') {
            return `${Math.round(totalHours / 24)}d`;
        }
        if (unit === 'h') {
            return `${Math.round(totalHours)}h`;
        }
        if (unit === 'm') {
            return `${Math.round(totalHours / (24 * 30))}m`;
        }
        if (unit === 'y') {
            return `${Math.round(totalHours / (24 * 365))}y`;
        }
    }

    totalHours = Math.floor(totalHours);
    let remaining = totalHours;

    const years = Math.floor(remaining / (24 * 365));
    remaining -= years * 24 * 365;

    const months = Math.floor(remaining / (24 * 30));
    remaining -= months * 24 * 30;

    const days = Math.floor(remaining / 24);
    remaining -= days * 24;

    const hours = remaining;

    const units = {
        y: { val: years, label: 'y' },
        m: { val: months, label: 'm' },
        d: { val: days, label: 'd' },
        h: { val: hours, label: 'h' }
    };

    const result = [];

    format.forEach(unit => {
        const u = units[unit];
        if (u && u.val > 0) {
            result.push(`${u.val}${u.label}`);
        }
    });

    if (result.length === 0) {
        const unit = format[format.length - 1];
        return `0${unit}`;
    }

    return result.join(' ');
};

const upsertValidatorExifAgeBadge = ($card, payload) => {
    const badgeId = 'validatorExifAgeBadge';
    const $existing = $card.find(`#${badgeId}`);


    const $badge = $existing.length ? $existing : $(`
        <div class="card-footer position-sticky bottom-0 pt-0">
            <div class="d-flex align-items-center justify-content-between"
                 id="${badgeId}"
                 style="top: 150px;">
              <div class="badge rounded-pill bg-info-subtle badge-validator-primary txt3 py-1 px-2 d-inline-flex align-items-center js-exif-age-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title=""
              >
                <i class="fa-regular fa-calendar me-2 opacity-50"></i>
                <span class="js-exif-age-title text-muted fw-medium txt1 me-2">Σ days: </span>
                <span class="js-exif-age-text fw-bold txt1"></span>
              </div>
              <small class="text-muted txt4 js-exif-age-subtext"></small>
            </div>
        </div>
    `);

    if (!$existing.length) {
        $card.append($badge);
    }

    const $tooltipTarget = $badge.find('.js-exif-age-tooltip').first();
    $tooltipTarget.attr('data-bs-title', `Σ Age: ${payload.coverage || ''}`);
    $tooltipTarget.attr('data-bs-original-title', `Σ Age: ${payload.coverage || ''}`);

    $badge.find('.js-exif-age-text').text(`${payload.coverage_days}`);
    $badge.find('.js-exif-age-subtext').text(payload.sublabel);

    const existingTooltip = bootstrap.Tooltip.getInstance($tooltipTarget[0]);
    if (existingTooltip) {
        existingTooltip.dispose();
    }
    new bootstrap.Tooltip($tooltipTarget[0]);
}

const updateValidatorExifAgeBadges = () => {
    $('.card').each(function () {
        const $card = $(this);

        const $table = $card.find('table.fb-element-dynamic-units').first();
        if ($table.length === 0) return;

        const seenIso = new Set();
        const dates = [];
        let imageCount = 0

        $table.find('.js-countable-fb-element tr').each(function () {
            if (!$(this).length) return;

            const exifText = $(this).find('.media-creation-date').first().text();
            if (!exifText) return;

            const iso = extractIsoDateFromText(exifText);
            if (!iso) return;

            if (seenIso.has(iso)) return;
            seenIso.add(iso);

            const d = new Date(iso);
            if (isNaN(d.getTime())) return;

            dates.push(d);
        });

        const imgToCount = $table.find('img.count-img-for-validator');
        if (imgToCount) {
            imageCount = imgToCount.length;
        }

        if (dates.length <= 1) {
            $card.find('#validatorExifAgeBadge').remove();
            return;
        }

        let earliestDate = dates[0];
        let latestDate = dates[0];

        for (let i = 1; i < dates.length; i++) {
            if (dates[i] < earliestDate) earliestDate = dates[i];
            if (dates[i] > latestDate) latestDate = dates[i];
        }

        const start = new Date(
            earliestDate.getFullYear(),
            earliestDate.getMonth(),
            earliestDate.getDate(),
            earliestDate.getHours (),
            earliestDate.getMinutes (),
            earliestDate.getSeconds ()
        );

        const end = new Date(
            latestDate.getFullYear(),
            latestDate.getMonth(),
            latestDate.getDate(),
            latestDate.getHours (),
            latestDate.getMinutes (),
            latestDate.getSeconds ()
        );

        const coverageDays = (end - start) / (1000 * 60 * 60 * 24);

        let props = {
            coverage_days: `${formatDurationFromDays(coverageDays, ['d'])}`,
            coverage: `${formatDurationFromDays(coverageDays, ['y','m','d','h'])}`
        }

        if (imageCount > 0) {
            props.sublabel = `Total ${imageCount} images (only ${dates.length} with EXIF date)` // • ${distinctDays} distinct calendar day(s)` }}
        }

        upsertValidatorExifAgeBadge($card, props);
    });
};

const initValidatorExifAgeListener = () => {
    if (window.__validatorExifAgeListenerInitialized) return;
    window.__validatorExifAgeListenerInitialized = true;

    const debouncedUpdate = debounceWhileSaving(function () {
        updateValidatorExifAgeBadges();
    }, 250);

    updateValidatorExifAgeBadges();

    const observer = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
            const m = mutations[i];
            if (m.type !== 'childList') continue;

            const nodes = [].concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []));
            for (let j = 0; j < nodes.length; j++) {
                const node = nodes[j];
                if (!node || node.nodeType !== 1) continue;

                if (
                    node.id === 'exif-info-wrapper' ||
                    node.classList.contains('image-exif-info-table') ||
                    (node.querySelector && (
                        node.querySelector('#exif-info-wrapper') ||
                        node.querySelector('.image-exif-info-table') ||
                        node.querySelector('table.fb-element-dynamic-units')
                    ))
                ) {
                    debouncedUpdate();
                    return;
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.fb-element-remove-button', () => { setTimeout(debouncedUpdate, 150); });
    $(document).on('change', 'input[type="file"]', () => { setTimeout(debouncedUpdate, 250); });
}


//-------------- isntructions.js:
const validatorShowHideDefinedInscrutions = (instructionVisibilityStatus) => {
    var $element = $('#can-be-hidden-by-vtb');

    if (instructionVisibilityStatus == 'shown') {
        $element.fadeIn();
    } else {
        $element.fadeOut();
    }
}

let validatorPlaybackSpeedObserver = null;

const normalizeValidatorPlaybackSpeed = (playbackSpeed) => {
    const parsedSpeed = parseFloat(playbackSpeed);
    return Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : 1;
}

const validatorPlaybackSpeedStorageKey = () => `${gon.user}_ValidatorPlaybackSpeed`;

const updateValidatorPlaybackSpeedIndicator = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    const isDefaultSpeed = normalizedSpeed === 1;
    const formattedSpeed = `${normalizedSpeed}x`;
    const playbackSpeedToggle = $('#playbackSpeedToggle');
    const tachometerIcon = playbackSpeedToggle.find('.fa-tachometer-alt');
    const speedBadge = playbackSpeedToggle.find('.validator-playback-speed-value');

    playbackSpeedToggle.toggleClass('validator-playback-speed-custom', !isDefaultSpeed);
    tachometerIcon.toggleClass('text-warning', !isDefaultSpeed);
    speedBadge.toggleClass('d-none', isDefaultSpeed).text(formattedSpeed);
    playbackSpeedToggle.find('> a').attr('aria-label', `Playback speed: ${formattedSpeed}`);
    tachometerIcon.attr({
        title: `Playback speed: ${formattedSpeed}`,
        'data-bs-original-title': `Playback speed: ${formattedSpeed}`,
        'data-bs-title': `Playback speed: ${formattedSpeed}`
    });

    $('#playbackSpeedControls li').removeClass('active');
    $('#playbackSpeedControls a').each(function (){
        if (parseFloat($(this).attr('data-feedback-speed')) === normalizedSpeed){
            $(this).closest('li').addClass('active');
        }
    });
}

const applyValidatorPlaybackSpeedToMedia = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    $('video, audio').each(function () {
        this.playbackRate = normalizedSpeed;
    });
}

const validatorPlaybackSpeed = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    localStorage.setItem(validatorPlaybackSpeedStorageKey(), normalizedSpeed);
    applyValidatorPlaybackSpeedToMedia(normalizedSpeed);
    updateValidatorPlaybackSpeedIndicator(normalizedSpeed);
}

const applyStoredValidatorPlaybackSpeed = () => {
    const storedPlaybackSpeed = localStorage.getItem(validatorPlaybackSpeedStorageKey());
    const playbackSpeed = storedPlaybackSpeed != null ? storedPlaybackSpeed : 1;

    applyValidatorPlaybackSpeedToMedia(playbackSpeed);
    updateValidatorPlaybackSpeedIndicator(playbackSpeed);
}

const observeValidatorPlaybackSpeedMedia = () => {
    if (validatorPlaybackSpeedObserver || !document.body) return;

    validatorPlaybackSpeedObserver = new MutationObserver((mutations) => {
        const mediaInserted = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
            node.nodeType === Node.ELEMENT_NODE &&
            (
                node.matches?.('video, audio') ||
                node.querySelector?.('video, audio')
            )
        )));

        if (mediaInserted) applyStoredValidatorPlaybackSpeed();
    });

    validatorPlaybackSpeedObserver.observe(document.body, { childList: true, subtree: true });
}

const validatorImageSize = (imgSize) => {
    if (imgSize == 'reset') {
        localStorage.removeItem(gon.user + '_ValidatorImageSize');
        $('body label + div > *').each(function () {
            $('img').each(function () {
                $(this).removeAttr('style');
            });
        });
    } else {
        localStorage.setItem(gon.user + '_ValidatorImageSize', imgSize);
        $('body label + div > *').each(function () {
            $('img').each(function () {
                $(this).width(imgSize).height('auto');
            });
        });
    }
}


//-------------- validate_images_count_badge.js:
const updateValidatorImagesCountBadge = () => {
    const $header = $('#jobsInfoHeader');
    if ($header.length === 0) return;

    const count = $('.count-img-for-validator').length;

    let $validatorImagesCountBadge = $header.find('#validatorImagesCountBadge');
    if ($validatorImagesCountBadge.length === 0) {
        $validatorImagesCountBadge = $(`
            <div class="badge rounded-pill badge-validator-primary txt3 px-2 d-flex align-items-center justify-content-center"
                 id="validatorImagesCountBadge"
                 style="background-color:rgba(26, 150, 240, 0.2);"
                 data-bs-toggle="tooltip"
                 data-bs-placement="bottom"
                 data-bs-html="true"
                 title=""
             >
                <span class="validator-images-count-text fw-bold txt1 me-2">${count}</span>
                <i class="fa-regular fa-images" style="opacity:.3"></i>
            </div>
            <span class="text-dark">|</span>
        `);
        $header.prepend($validatorImagesCountBadge);
    }

    const lines = [];
    $('.js-countable-fb-element').each(function() {
        const $countable = $(this);
        const $formRow = $countable.closest('.form-row');
        let $label = $formRow.find('.element-label-anchor').first();
        if ($label.length === 0) return;

        const labelName = ($label.find('p').first().text() || $label.text() || '').trim();
        if (!labelName) return;

        const labelCounter = ($formRow.find('.js-label-counter').first().text() || '').trim();
        lines.push(`<div class="d-flex flex-row align-items-center justify-content-between txt4 w-100">${escapeHTML(labelName)} <strong class="ms-3">${escapeHTML(labelCounter)}</strong></div>`);
    });
    $validatorImagesCountBadge.find('.validator-images-count-text').text(count);

    const tooltipHtml = lines.length ? `<div class="d-flex flex-column row-gap-2">${lines.join('\n')}</div>` : null

    if (!tooltipHtml) return;
    $validatorImagesCountBadge.attr('data-bs-original-title', tooltipHtml).attr('title', tooltipHtml);

    const validatorImagesCountBadgeTooltip = $validatorImagesCountBadge[0]
    const existing = bootstrap.Tooltip.getInstance(validatorImagesCountBadgeTooltip);
    if (existing) existing.dispose();
    new bootstrap.Tooltip(validatorImagesCountBadgeTooltip)
}

const initValidatorImagesCountListener = () => {
    if (window.__validatorImagesCountListenerInitialized) return;
    window.__validatorImagesCountListenerInitialized = true;

    const debouncedImgCountUpdate = debounceWhileSaving(() => {
        updateValidatorImagesCountBadge();
    }, 200);

    updateValidatorImagesCountBadge();

    const observer = new MutationObserver( (mutations) => {
        for (let i = 0; i < mutations.length; i++) {
            const m = mutations[i];
            if (m.type === 'childList') {
                const nodes = [].concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []))
                for (let j = 0; j < nodes.length; j++) {
                    const node = nodes[j];
                    if (!node || node.nodeType !== 1) continue;

                    if ( node.classList.contains('validator-images-count-text') ||
                        (node.querySelector && node.querySelector('.validator-images-count-text')) ) {
                        debouncedImgCountUpdate();
                        return;
                    }
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.fb-element-remove-button', () => { setTimeout(debouncedImgCountUpdate, 100); });

    $(document).on('change', 'input[type="file"]', () => { setTimeout(debouncedImgCountUpdate, 200); });
}


const validatorShowHideInscrutions = (validatorInstructionsStatus) => {
    $(document).find('body .card:not(.always-shown-vtb)').each(function () {
        let card = $(this);
        let containsInputVideoAudio = card.find(':input, textarea, table video, audio').length > 0;
        let elementsAreHiddenForValidator = card.find('.hide-instructions-for-validator').length > 0;

        if (validatorInstructionsStatus == 'shown' || elementsAreHiddenForValidator) {
            card.find('.hide-instructions-for-validator').fadeIn().removeClass('hide-instructions-for-validator');

            card.show();

            $('.validatorShowHideInscrutions')
                .attr('title', I18n.t("validation_toolbox.hide_instruction"))
                .find('.far.fa-eye')
                .removeClass('far fa-eye')
                .addClass('fas fa-eye-slash')
                .end();
            document.querySelectorAll('.validatorShowHideInscrutions').forEach(function (tooltipElement) {
                let tooltipInstance = bootstrap.Tooltip.getInstance(tooltipElement);
                if (tooltipInstance) {
                    tooltipInstance.dispose();
                }
                new bootstrap.Tooltip(tooltipElement);
            });
        } else if (!containsInputVideoAudio) {
            card.find('img').not($('table img, img[src*="gif"]')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('img[src*="gif"]').fadeIn().removeClass('hide-instructions-for-validator');
            card.find('p').not($('table p, #can-be-hidden-by-vtb p, .can-be-pinned-by-validator p, p:has(img[src*=".gif"]), p:has(audio), p:has(video)')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('p ~ ul').not($('table ul, ul.playback-speed')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('ol').not($('table ol')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('h2').not($('table h2')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('video').not($('table video')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('div#can-be-hidden-by-vtb').fadeOut().addClass('hide-instructions-for-validator');


            $.when(card.find(':animated').promise()).then(function() {
                let relevantChildren = card.find('.form-row > *');
                let visibleNonValidatorChildren = relevantChildren.filter(':visible').not('.hide-instructions-for-validator');

                card.find('.bg-light').addClass('test');
                if (visibleNonValidatorChildren.length === 0) {
                    card.hide();
                } else {
                    card.show();
                }
            });

            $('.validatorShowHideInscrutions')
                .attr('title', I18n.t("validation_toolbox.show_instruction"))
                .find('.fas.fa-eye-slash')
                .removeClass('fas fa-eye-slash')
                .addClass('far fa-eye')
                .end();
            document.querySelectorAll('.validatorShowHideInscrutions').forEach(function (tooltipElement) {
                let tooltipInstance = bootstrap.Tooltip.getInstance(tooltipElement);
                if (tooltipInstance) {
                    tooltipInstance.dispose();
                }
                new bootstrap.Tooltip(tooltipElement);
            });
        }

    });
}


function getCommentListForValidatorModal() {
    var storedLabels = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments'));
    if (storedLabels) {
        var $validatorCommentsModalList = $('<ul class="list-group">');
        $.each(storedLabels, function (index, value) {
            var $ModalCommentList = $('<li class="d-flex flex-row list-group-item justify-content-between align-items-center"></li>');
            var $ModalCommentLabel = $('<div class="label-text"  contenteditable="true"></div>').text(value);
            var $ModalDeleteCommentBtn = $('<a href="#" class="btn btn-sm delete-validation-comment rounded-circle border-0"><i class="far fa-trash-alt"></i></a>');

            $ModalCommentList.append($ModalCommentLabel).append($ModalDeleteCommentBtn);
            $validatorCommentsModalList.append($ModalCommentList);
        });
        $('#validatorToolboxModal .modal-body').empty();
        $('#validatorToolboxModal .modal-body').html($validatorCommentsModalList);

        var $addNewCommentBtn = $('<a href="#" class="btn btn-primary add-comment-btn">' + I18n.t('validation_toolbox.modal_addnewcomment') + '</a>');
        $('#validatorToolboxModal .modal-body').append($addNewCommentBtn);

        $addNewCommentBtn.on('click', function (e) {
            e.preventDefault();
            var $newCommentLi = $('<li class="d-flex flex-row list-group-item justify-content-between align-items-center"></li>');
            var $newCommentLabel = $('<div class="label-text" contenteditable="true"></div>');
            var $newDeleteCommentBtn = $('<a href="#" class="btn btn-sm delete-validation-comment rounded-circle border-0"><i class="far fa-trash-alt"></i></a>');
            $newCommentLi.append($newCommentLabel).append($newDeleteCommentBtn);
            $validatorCommentsModalList.append($newCommentLi).find('.label-text').focus();
        });
    }
    $('#validatorToolboxModal .modal-footer .modal-submit-button-wrapper').html('<a href="#" type="button" class="btn btn-primary" id="SavevalidatorToolboxModal" data-bs-dismiss="modal">' + I18n.t("validation_toolbox.modal_save") + '</a>');
}


function appendCommentListToValidationToolbox() {
    if (localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments') == null) {
        const now = new Date();
        const toolboxListCreationtimeStamp = formatDate(now);

        var labels = $('.validation-declination-reasons input[type="checkbox"]').siblings('label');
        var labelTexts = [];
        labels.each(function () {
            if ($(this).text() != null) {
                labelTexts.push($(this).text().trim());
            }
        });
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments', JSON.stringify(labelTexts));
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate', toolboxListCreationtimeStamp);
    }
    var storedLabels = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments'));
    if (storedLabels) {
        var $select = $('<select class="form-control selectpicker" id="validator_notAcceptedComments_dropdown" multiple data-live-search="true" data-width="100%" data-selected-text-format="count" title="'+ I18n.t("validation_toolbox.choose_a_comment") +'">');
        $.each(storedLabels, function (index, value) {
            $select.append($('<option>').text(value).val(value));
        });
        $('body #toolbox-validation-comments-selection').html($select);
        $('#validator_notAcceptedComments_dropdown.selectpicker').selectpicker();
    }
    $('#toolbox-validation-comments-selection .selectpicker').on('show.bs.select', function () {
        var currentScroll = $(window).scrollTop();
        $(window).one('scroll', function () {
            $(window).scrollTop(currentScroll);
        });
    });
    attachSelectpickerEventListener();
}

appendMainValidationToolSections = () => {
    const storedData = JSON.parse(localStorage.getItem(`${gon.user}_${node_config_id}_${job_task_id}_commentSectionsData`)) || {};
    const $allCommentBoxes = $('.validation-tool-comment-box');
    let mainIndex = 1;

    if ($allCommentBoxes.length === 0) return;

    const handledBoxes = new Set();

    $allCommentBoxes.each(function () {
        const $box = $(this);
        const commentMediaId = $(this).attr('data-media-id');
        const commentMedianame = $(this).attr('data-media-name');
        if (handledBoxes.has($box[0])) return;

        const $wrapper = $box.closest('table.fb-element-dynamic-units');
        const $groupBoxes = $wrapper.find('.validation-tool-comment-box');

        if ($wrapper.length && $groupBoxes.length > 1) {
            let subIndex = 1;

            $groupBoxes.each(function () {
                const $subBox = $(this);
                if (handledBoxes.has($subBox[0])) return;

                const commentBoxId = `${mainIndex}.${subIndex}`;
                handledBoxes.add($subBox[0]);

                renderValidationToolBox($subBox, commentBoxId, commentMediaId, commentMedianame, storedData, true, subIndex);
                subIndex++;
            });
            mainIndex++;
        } else {
            const commentBoxId = `${mainIndex}`;
            handledBoxes.add($box[0]);

            renderValidationToolBox($box, commentBoxId, commentMediaId, commentMedianame, storedData);
            mainIndex++;
        }
    });

    appendCommentListToValidationToolbox();
};

renderValidationToolBox = ($box, commentBoxId, commentMediaId, commentMediaName, storedData, isASubChild = false, subIndex = null) => {
    const $listOfComments = $('<ul class="ps-3 m-0"></ul>');
    const mediaIdentifier = commentMediaId || commentMediaName || commentBoxId

    if (storedData[mediaIdentifier]) {
        storedData[mediaIdentifier].forEach(comment => {
            $listOfComments.append($('<li>').text(comment));
        });
        $('#validator-comments-reminder').addClass('show');
    } else {
        $listOfComments.append($('<li>'));
    }

    const title = I18n.t("validation_toolbox.task_n_validation", { TaskNumber: commentBoxId });

    const $elementsToolboxHTMLContent = $('<div>').append(
        $('<p>').addClass('text-primary fw-light').text(title),
        $('<div>').addClass('row mb-3').append(
            $('<div>').addClass('col').attr('id', 'toolbox-validation-comments-selection')
        ),
        $('<div>').addClass('row').append(
            $('<div>').addClass('col').append(
                $('<div>')
                    .addClass('m-0 form-control bg-white border-0')
                    .attr('id', 'toolbox-element-validation-comments')
                    .attr('contenteditable', 'true')
                    .attr('data-comment-media-id', commentMediaId)
                    .attr('data-comment-media-name', commentMediaName)
                    .attr('data-comment-box-id', commentBoxId)
                    .attr('data-comment-box-subindex-id', subIndex)
                    .append(
                        $('<p>').text(`${isASubChild? subIndex + ') ' : ''}${$box.closest('.card-body').find('label:first').text()}:`),
                        $listOfComments
                    )
            )
        )
    );

    $box.html($elementsToolboxHTMLContent).attr('data-element-box-id', commentBoxId);
};

function resetMainValidationToolComment(){
    localStorage.removeItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments');
    appendCommentListToValidationToolbox();
    getCommentListForValidatorModal();

    $('#toolbox-validation-comments-selection.selectpicker').selectpicker();
    attachSelectpickerEventListener();
}

function attachSelectpickerEventListener() {
    $('#toolbox-validation-comments-selection .selectpicker').on('change.bs.select', function(e) {
        let commentMediaId = $(this).closest('.validation-tool-comment-box').attr('data-media-id');
        let commentMediaName = $(this).closest('.validation-tool-comment-box').attr('data-media-name');
        let commentBoxId = $(this).closest('.validation-tool-comment-box').attr('data-element-box-id');
        var $destinationTextArea = $(this).closest('.validation-tool-comment-box').find('#toolbox-element-validation-comments ul');
        var $selectedOptions = $(this).val() || [];
        let storageData = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData')) || {};
        const mediaIdentifier = commentMediaId || commentMediaName || commentBoxId;

        if (!Array.isArray(storageData[mediaIdentifier])) {
            storageData[mediaIdentifier] = [];
        }

        let newComments = $selectedOptions.filter(function(comment) {
            return !storageData[mediaIdentifier].includes(comment);
        });

        if (newComments.length > 0) {
            $destinationTextArea.find('li').filter(function() {
                return $(this).text().trim() === '';
            }).remove();
            newComments.forEach(function (comment) {
                var $commentItem = $('<li></li>').text(comment);
                $destinationTextArea.append($commentItem);
                storageData[mediaIdentifier].push(comment);
            });
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData', JSON.stringify(storageData));
            $('#validator-comments-reminder').addClass('show');
        }
    });
}


function appendMainValidationToolCollectCommentSections() {
    var collectCommentContainer = $('.validation-tool-comments-collect-box');
    var validatorInfoNotice = $(`
        <div class="alert alert-warning alert-dismissible fade" id="validator-comments-reminder" role="alert">
          <ul class="ps-3 mb-0"><li>Please ensure that you have inserted all your comments before submitting the job.</li></ul>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    `);
    if (collectCommentContainer && $('.validation-tool-comment-box').length > 0) {
        collectCommentContainer.html('<div class="row align-items-center">' +
            '<div class="col-auto">' +
            '<p class="text-primary fw-light m-0 lh-1">'+ I18n.t("validation_toolbox.collect_allValidation_1stline") +'<br>'+ I18n.t("validation_toolbox.collect_allValidation_2ndline") +'</p>' +
            '</div>' +
            '<div class="col-auto d-flex flex-row">' +
            '<a href="#" class="btn btn-primary collectAllValidationsToolboxComments">'+ I18n.t("validation_toolbox.add_to_my_final_comment") +'</a>' +
            '<a href="#" class="btn btn-outline-primary modalAllValidationsToolboxComments" data-bs-toggle="modal" data-bs-target="#validatorToolboxModal">'+ I18n.t("validation_toolbox.show_before_adding") +'</a>' +
            '</div>' +
            '</div>');
        collectCommentContainer.closest('.card-body').append(validatorInfoNotice);
    }

}


getAllCommentsForValidatorToTextarea = (dataSource) => {
    const $reviewDataJson = $('input[id*="_review_data"]');
    const $finalReviewerCommentTextarea = $('[id*="_review_comment"]');
    const $collectedRawCommentsContainer = $('#display_review_comment');

    const defaultText = $('#job_resubmission_check').is(':checked') ? I18n.t("validation_toolbox.thanks_text_comments_resubmission") : I18n.t("validation_toolbox.thanks_text_comments");
    const currentText = dataSource ? $('#ModalValidatorFinalCommentsTextarea').text() || defaultText : $finalReviewerCommentTextarea.val() || defaultText;

    let finalValidatorComment = "";
    let commentsMap = {};

    const $validationsComment = $('.validation-tool-comment-box #toolbox-element-validation-comments');
    const allValidations = [];
    let isFirstParagraph = true;

    $validationsComment.find('li').filter((_, li) => $(li).text().trim() === '').remove();

    $validationsComment.each(function () {
        const $box = $(this);
        const $liElements = $box.find('li');
        const $mainCommentsWrapper = $liElements.closest('#toolbox-element-validation-comments');
        const mediaSlug = $box.closest('.validation-tool-comment-box').attr('data-media-id');
        const mediaName = $box.closest('.validation-tool-comment-box').attr('data-media-name');
        const subindex = $mainCommentsWrapper.first().attr('data-comment-box-subindex-id');


        const liTexts = $liElements.map((_, li) => $(li).text().trim()).get().filter(Boolean);

        const $closestInput = $box.closest('.card-body').find('input[id]').first();
        const inputId = $closestInput.attr('id');

        if (inputId && liTexts.length > 0) {
            const normalizedId = inputId.replace(/^.*?_df_create_?/, '').replace(/_+$/, '');

            const elementSlug = normalizedId;
            const mediaKey = mediaSlug || mediaName || (subindex ? String(parseInt(subindex, 10) - 1) : '0');

            if (!commentsMap[elementSlug]) commentsMap[elementSlug] = { sub: {} };

            const commentsArray = Array.isArray(liTexts)
                ? liTexts
                : String(liTexts || '')
                    .split('\n')
                    .map(s => s.trim())
                    .filter(Boolean);

            commentsMap[elementSlug].sub[mediaKey] = commentsArray;
        }

        if ($liElements.length > 0) {
            $box.find('p, li').each(function () {
                const text = $(this).text().trim();
                if (!text) return;

                if ($(this).is('p')) {
                    allValidations.push((isFirstParagraph ? "" : "\n") + text + "\n");
                    isFirstParagraph = false;
                } else {
                    allValidations.push(text + "\n");
                }
            });
        }
    });

    finalValidatorComment = allValidations.join('');

    const isConfirmed = $finalReviewerCommentTextarea.val() !== null && $finalReviewerCommentTextarea.val().trim() !== ""
        ? confirm(I18n.t('validation_toolbox.prompt_collect_comments'))
        : true;

    if (!isConfirmed) return false;

    const commentsMapStr = JSON.stringify(commentsMap, null, 2);
    $reviewDataJson.val(commentsMapStr);
    $finalReviewerCommentTextarea
        .val(currentText)
        .attr('data-comments', finalValidatorComment)
        .height('auto');
    $collectedRawCommentsContainer.text(finalValidatorComment);

    const prefix = gon.user + '_' + node_config_id + '_' + job_task_id;
    localStorage.setItem(prefix + '_validator_CustomComments', currentText);
    localStorage.setItem(prefix + '_validator_allComments_plain', finalValidatorComment);
    localStorage.setItem(prefix + '_validator_allComments_json', commentsMapStr);
}


function getAllCommentsForValidatorModal() {
    var $finalReviewerModalTextarea = $('<div id="ModalValidatorFinalCommentsTextarea" class="form-control h-auto" contenteditable="true"></div>');
    var $finalReviewerModalNonEditableComment = $('<div id="ModalValidatorFinalCollectedComments" class="form-control h-auto"></div>');
    var $validationsComment = $('.validation-tool-comment-box #toolbox-element-validation-comments');
    var allValidations = [];
    var isFirstParagraph = true;
    var $finalReviewerCommentTextareaValue = $('[id*="_review_comment"]').val();

    $validationsComment.find('li').filter(function() {
        return $(this).text().trim() === '';
    }).remove();
    $validationsComment.each(function () {
        if ($(this).find('li').length > 0) {
            var $commentBox = $(this);
            $commentBox.find('p, li').each(function () {
                var $element = $(this);
                var commentText = $element.text().trim();
                if (commentText) {
                    if ($element.is('p')) {
                        if (isFirstParagraph) {
                            allValidations.push(commentText + '\n');
                            isFirstParagraph = false;
                        } else {
                            allValidations.push('\n' + commentText + '\n');
                        }
                    } else if ($element.is('li')) {
                        allValidations.push(commentText + '\n');
                    }
                }
            });
        }
    });
    var finalValidatorComment = allValidations.join('');
    $('#validatorToolboxModal #manage-validation-comment').html($finalReviewerModalTextarea.html($finalReviewerCommentTextareaValue).attr('data-comments', finalValidatorComment))
    if (finalValidatorComment.length) {
        $('#validatorToolboxModal #manage-validation-comment').append($finalReviewerModalNonEditableComment.html(finalValidatorComment));
    } else {
        $('#ModalValidatorFinalCollectedComments').empty();
    }
    $('#validatorToolboxModal .modal-footer .modal-submit-button-wrapper').html('<a href="#" type="button" class="btn btn-primary collectAllValidationsToolboxComments" data-bs-dismiss="modal">'+ I18n.t("validation_toolbox.add_to_my_final_comment") +'</a>');
}


function appendPinnedContent(text, pinnedId) {
    var prefix = pinnedId.includes('age') ? "Age: " : pinnedId.includes('countryCode') ? 'Country Code: ' :  pinnedId.includes('openTaskNbr') ? 'Open Jobs: ' :'';
    var spanHtml = `<div class="badge rounded-pill badge-validator-primary validator-pinned-infos txt4" data-badge-pinned="${pinnedId}">
                        <span contenteditable="true">${prefix}${text}</span>
                        <a href="#" class="remove-pinned-info">
                            <i class="fas fa-times"></i>
                        </a>
                    </div>`;
    $('#jobsInfoHeader').append(spanHtml);
}


$(document).on('load turbolinks:load', function() {
    if (!window.node_config_id) return;

    $(document).find('body').addClass('validation-job');
    $(document).on('click', '#playbackSpeedControls a', function (e) {
        let playbackSpeed = $(this).attr('data-feedback-speed');
        validatorPlaybackSpeed(playbackSpeed);
        $(this).closest('ul').find('.list-inline-item').removeClass('active');
        $(this).closest('.list-inline-item').addClass('active');
        e.preventDefault();
    });

    $(document).on('click', '#imagesSizeControls a', function (e) {
        e.preventDefault();
        let imgSize = $(this).data('images-size');
        validatorImageSize(imgSize);
        $(this).closest('ul').find('.list-inline-item').removeClass('active');
        $(this).closest('.list-inline-item').addClass('active');
    });

    $(document).on('click', '#validatorCommentModalButton', function (e) {
        getCommentListForValidatorModal();
    });

    $(document).on('click', '.modalAllValidationsToolboxComments', function (e) {
        e.preventDefault();
        getAllCommentsForValidatorModal();
    });

    $(document).on('click', '.collectAllValidationsToolboxComments', function (e) {
        e.preventDefault();
        if ($(this).attr('data-bs-dismiss')) {
            getAllCommentsForValidatorToTextarea('forModal');
        } else {
            getAllCommentsForValidatorToTextarea();
        }
    });

    $(document).on('mouseover', '#playbackSpeedToggle', function(e) {
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")) {
            dropdownMenu.parent().toggleClass("open");
        }
    });

    $(document).on('click', '.delete-validation-comment', function(e) {
        e.preventDefault();
        $(this).closest('li').remove();
    });


    attachSelectpickerEventListener()
    observeValidatorPlaybackSpeedMedia();
    applyStoredValidatorPlaybackSpeed();

    if ($('.validation-tool-comment-box').length == 0){
        $('.for-validatorCommentModalButton').hide();
    }

    if(localStorage.getItem(gon.user+'_ValidatorImageSize')!=undefined){
        validatorImageSize(localStorage.getItem(gon.user+'_ValidatorImageSize'));
        $('#imagesSizeControls li').removeClass('active');
        $('#imagesSizeControls a').each(function (){
            if ($(this).attr('data-images-size') == localStorage.getItem(gon.user+'_ValidatorImageSize')){
                $(this).closest('li').addClass('active');
            }
        });
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_json') != null && ($('input[id*="_review_data"]').length)) {
        var validator_allComments_json = localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_json')
        $('input[id*="_review_data"]').val(validator_allComments_json);
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_plain') != null && $('textarea[id*="_review_comment"]').length) {
        var validator_allComments_plain = localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_plain')
        $('textarea[id*="_review_comment"]').attr('data-comments', validator_allComments_plain);
        $('#display_review_comment').text(validator_allComments_plain);
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments') != null && ($('textarea[id*="_review_comment"]').length || $('#ModalValidatorFinalCommentsTextarea').length)) {
        $('textarea[id*="_review_comment"]').val(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments')).height('auto');
    }

    if ($('textarea[id*="_review_comment"]').length) {
        var saveFinalCommentToLocalStorage = debounceWhileSaving(function () {
            var textarea = $(this);
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments', textarea.val());
        }, 1000);

        $('textarea[id*="_review_comment"]').on('keydown', saveFinalCommentToLocalStorage)
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content')) {
        var pinnedContentText, pinnedId = ""
        var pinnedContents = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content').split(';');
        pinnedContents.forEach(function(pinnedContent) {
            if (pinnedContent.includes('dynamic_')){
                pinnedContentText = $(`.can-be-pinned-by-validator[data-to-pinn="${pinnedContent}"]`).text().trim();
                pinnedId = pinnedContent;
            } else {
                pinnedContentText = pinnedContent;
            }
            if (pinnedContentText.trim() !== '') {
                appendPinnedContent(pinnedContentText, pinnedId);
            }
        });
    }

    if (localStorage.getItem(gon.user+'_validator-toolbox') != null && localStorage.getItem(gon.user+'_validator-toolbox') == 'hidden'){
        hideValidatorToolbox('hidden');
    }

    $('.can-be-pinned-by-validator').each(function () {
        var $this = $(this);
        var dataToPinn = $this.attr('data-to-pinn');
        if ($this.find('.pin-to-jobsInfoHeader').length == 0) {
            var localStorageData = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content');
            var showBtnStatus = "";
            if (localStorageData != null && localStorageData.includes(dataToPinn)) {
                showBtnStatus = "display: none";
            }
            var $buttonHtml = `<a href="#" role="button" class="btn btn-sm btn-primary pin-to-jobsInfoHeader rounded-circle my-0" style="${showBtnStatus}"><i class="fas fa-plus"></i></a>`;
            $this.append($buttonHtml);
        }
    });

    $(document).find('.card:not(.always-shown-vtb)').each(function(){
        if (!$(this).hasClass('bg-light') && !$(this).hasClass('validation-card-wrapper') && ($(this).find('.form-row').children().length <= 0)){
            $(this).addClass('d-none');
        }
    })

    initValidatorImagesCountListener();
    initValidatorExifAgeListener();


    if (window.batch_config_updated_at) {
        var shouldShowModal = false;
        var lastUpdate = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate');
        var notAcceptedComments = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments');

        if ((lastUpdate == null && notAcceptedComments != null) ||
            (lastUpdate != null && new Date(window.batch_config_updated_at) > new Date(lastUpdate))) {
            $('#resetCommentList').removeClass('d-none');
            $('a#validatorCommentModalButton').append('<span class="badge-pulse"><small></small></span>');

            new Noty({
                type: 'error',
                layout: 'topRight',
                theme: 'bootstrap-v4',
                text: '<div class="row">'+
                        '<div class="col">'+
                            '<strong class="txt2">' +
                                '<i class="fas fa-exclamation-triangle"></i> ' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert_title") +
                            '</strong>' +
                            '<p class="txt2 my-2 text-white">' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert") +
                            '</p>' +
                            '<a href="#" class="btn btn-light text-danger mx-0">' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert_btn") +
                            '</a>' +
                        '</div>'+
                    '</div>',
                animation: {
                    open : 'animated fadeInRight',
                    close: 'animated fadeOutRight'
                },
            }).on('onClick', function () {
                getCommentListForValidatorModal();
                new bootstrap.Modal('#validatorToolboxModal').show();
            }).show();
        } else {
            $('#resetCommentList').remove();
        }

    } else {
        $('#resetCommentList').remove();
    }

    if (window.node_config_id) {
        if (localStorage.getItem(gon.user + '_' + node_config_id + '_validator_instructions') != null) {
            var validatorInstructionsStatus = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_instructions')
            validatorShowHideDefinedInscrutions(validatorInstructionsStatus);
            validatorShowHideInscrutions(validatorInstructionsStatus);
        }

        var saveElementValidationCommentToLocalStorage = debounceWhileSaving(function (dataToStore) {
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData', JSON.stringify(dataToStore));
        }, 1000); // 1000ms between each change
    }

    $('#validatorToolboxModal').on('hidden.bs.modal', function () {
        $(this).find('.modal-body').empty();
    });

    $(document).on('click', '#resetCommentList', function (e) {
        $(this).addClass('d-none');
        // $(this).tooltip('hide');
        $(this).fadeOut('fast', function() {
            resetMainValidationToolComment();
            $(this).remove();
            $(document).find('a#validatorCommentModalButton .badge-pulse').remove();
        });
    });

    $(document).on('click', '.hide-validator-toolbox', function (e) {
        e.preventDefault();
        hideValidatorToolbox();
    });

    $(document).on('click', '#toggle-validation-comment-box', function (e) {
        e.preventDefault();
        $('.validation-tool-comment-box').toggleClass('d-none');
        $('.validation-tool-comments-collect-box').toggleClass('d-none');
        $(this).find('.form-check-input').toggleClass('checked').prop('checked', function(_, val) {
            return !val;
        });
    });

    $(document).on('click', '.validatorShowHideInscrutions', function (e) {
        e.preventDefault();
        let validatorInstructionsStatus = $("body").find('.hide-instructions-for-validator').length > 0 ? 'shown' : 'hidden'
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_instructions', validatorInstructionsStatus);
        validatorShowHideDefinedInscrutions(validatorInstructionsStatus);
        validatorShowHideInscrutions(validatorInstructionsStatus);
    });

    $(document).on('click', '.pin-to-jobsInfoHeader', function(e) {
        e.preventDefault();
        var parentText = $(this).closest('.can-be-pinned-by-validator').text().trim();
        var pinnedElementId = $(this).closest('.can-be-pinned-by-validator').attr('data-to-pinn');
        appendPinnedContent(parentText, pinnedElementId);
        var existingPinnedContent = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content');
        if (existingPinnedContent) {
            existingPinnedContent += pinnedElementId + ';';
        } else {
            existingPinnedContent = pinnedElementId + ';';
        }
        $(this).fadeOut(100);
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', existingPinnedContent);
    });


    $(document).on('keyup', '#toolbox-element-validation-comments', function(e) {
        let commentMediaId = $(this).closest('.validation-tool-comment-box').attr('data-media-id');
        let commentMediaName = $(this).closest('.validation-tool-comment-box').attr('data-media-name');
        let commentBoxId = $(this).closest('.validation-tool-comment-box').attr('data-element-box-id');
        let commentMediaIdentifier = commentMediaId || commentMediaName || commentBoxId;
        let $commentList = $(this).find('ul');
        let storedData = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData')) || {};
        let validationElementsComments = [];
        $commentList.find('li').each(function () {
            var commentText = $(this).text().trim();
            if (commentText !== '') {
                validationElementsComments.push(commentText);
            }
        });
        storedData[commentMediaIdentifier] = validationElementsComments;
        saveElementValidationCommentToLocalStorage(storedData);
    });

    $(document).on('keyup', '#toolbox-element-validation-comments', function(e) {
        let $commentBox = $(this);
        let $commentList = $commentBox.find('ul');
        let subIndexid = $(this).attr('data-comment-box-subindex-id');
        let counter = subIndexid ? `${subIndexid}) ` : '';

        if ($commentList.length === 0 || $commentList.find('li').length === 0) {
            $commentBox.append('<ul class="ps-3 m-0"><li></li></ul>');
        }
        if ($commentBox.find('p').text().trim() === "") {
            $commentBox.find('p').html(`${counter}${$commentBox.closest('.card-body').find('label:first').text() + ':'}`);
        }
        if ($commentBox.find('p').length === 0) {
            $commentBox.prepend(`<p><strong>${counter}${$commentBox.closest('.card-body').find('label:first').text()}:</strong></p>`);
        }
    });

    $(document).on('paste', '.validator-pinned-infos span[contenteditable]', function(e) {
        var pastedText = '';
        if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
            pastedText = e.originalEvent.clipboardData.getData('text/plain');
        } else if (window.clipboardData && window.clipboardData.getData) {
            pastedText = window.clipboardData.getData('text/plain');
        }
        document.execCommand('insertText', false, pastedText);
    });

    $(document).on('blur', '.validator-pinned-infos span[contenteditable]', function() {
        var updateIsDone = false;
        var updatedPinnedContent = "";
        var currentPinnedContent = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
        var updatedPinnedId = $(this).closest('.validator-pinned-infos').addClass('with-updated-text').attr('data-badge-pinned');
        if (currentPinnedContent.length > 0) {
            var contentPinnedArray = currentPinnedContent.split(';');
            for (var i = 0; i < contentPinnedArray.length; i++) {
                if (contentPinnedArray[i].includes(updatedPinnedId) && !updateIsDone) {
                    contentPinnedArray[i] = $(this).text().trim();
                    updateIsDone = true;
                }
            }
            updatedPinnedContent = contentPinnedArray.join(';');
        }
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
    });

    $(document).on('click', '.remove-pinned-info', function(e) {
        var badgePinned = $(this).closest('.badge').attr("data-badge-pinned");
        $(document).find('.can-be-pinned-by-validator[data-to-pinn="' + badgePinned + '"]').find('.pin-to-jobsInfoHeader').fadeIn(300);
        e.preventDefault();
        $(this).closest('.badge').remove();
        var updatedPinnedContent = "";
        $('.validator-pinned-infos').each(function() {
            if ($(this).hasClass('with-updated-text')){
                updatedPinnedContent += $(this).find('span[contenteditable]').text().trim() + ';';
            } else {
                updatedPinnedContent += $(this).attr('data-badge-pinned') + ';';
            }
        });
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
    });

    $(document).on('click', '#SavevalidatorToolboxModal', function(e) {
        e.preventDefault();
        var commentList = $('#validatorToolboxModal .modal-body#manage-validation-comment .list-group-item');
        var commentListToSave = [];
        commentList.each(function() {
            if ($(this).find('.label-text').text().trim() != "") {
                commentListToSave.push($(this).find('.label-text').text().trim());
            }
        });
        localStorage.setItem(gon.user+'_'+ node_config_id +'_validator_notAcceptedComments', JSON.stringify(commentListToSave));
        appendCommentListToValidationToolbox();
        attachSelectpickerEventListener();
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate', formatDate(new Date()));
    });
    if (window.node_config_id) {
        appendMainValidationToolCollectCommentSections();
        appendMainValidationToolSections();
    }

    $(document).on('submit', 'form#edit_job', function (e) {
        const $textarea = $('textarea[id*="_review_comment"]');
        const raw = $textarea.attr('data-comments');
        const dataComments = raw ? String(raw).trim() : '';
        const currentValue = ($textarea.val() || '').trim();
        if ($textarea.length && dataComments && !currentValue.includes(dataComments)) {
            $textarea.val((currentValue + '\n\n' + dataComments).trim());
        }
    });
});
//ToDo:
//Split & migrate to smaller function based files.

//-------------- utils.js
const debounceWhileSaving = (func, wait, immediate) => {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

const formatDate = (date) => {
    const pad = (num) => num < 10 ? '0' + num : num;
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const escapeHTML = (str) => {
    return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

const extractIsoDateFromText = (text) => {
    const str = String(text || '').trim();
    const match = str.match(/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2}))/);
    return match ? match[1] : null;
}

const hideValidatorToolbox = (shouldShow) => {
    if (shouldShow != undefined) {
        $('#validator-toolbox').addClass('hidden');
    } else {
        if ($('#validator-toolbox').hasClass('hidden')) {
            $('#validator-toolbox').removeClass('hidden');
            localStorage.setItem(gon.user + '_validator-toolbox', 'shown');
        } else {
            $('#validator-toolbox').addClass('hidden');
            localStorage.setItem(gon.user + '_validator-toolbox', 'hidden');
        }
    }
}

//-------------- exif_age_badge.js:

const formatDurationFromDays = (totalDays, format = ['y','m','d','h']) => {

    if (!isFinite(totalDays) || totalDays <= 0) {
        const unit = format[format.length - 1] || 'd';
        return `0${unit}`;
    }

    let totalHours = totalDays * 24;

    if (format.length === 1) {
        const unit = format[0];
        if (unit === 'd') {
            return `${Math.round(totalHours / 24)}d`;
        }
        if (unit === 'h') {
            return `${Math.round(totalHours)}h`;
        }
        if (unit === 'm') {
            return `${Math.round(totalHours / (24 * 30))}m`;
        }
        if (unit === 'y') {
            return `${Math.round(totalHours / (24 * 365))}y`;
        }
    }

    totalHours = Math.floor(totalHours);
    let remaining = totalHours;

    const years = Math.floor(remaining / (24 * 365));
    remaining -= years * 24 * 365;

    const months = Math.floor(remaining / (24 * 30));
    remaining -= months * 24 * 30;

    const days = Math.floor(remaining / 24);
    remaining -= days * 24;

    const hours = remaining;

    const units = {
        y: { val: years, label: 'y' },
        m: { val: months, label: 'm' },
        d: { val: days, label: 'd' },
        h: { val: hours, label: 'h' }
    };

    const result = [];

    format.forEach(unit => {
        const u = units[unit];
        if (u && u.val > 0) {
            result.push(`${u.val}${u.label}`);
        }
    });

    if (result.length === 0) {
        const unit = format[format.length - 1];
        return `0${unit}`;
    }

    return result.join(' ');
};

const upsertValidatorExifAgeBadge = ($card, payload) => {
    const badgeId = 'validatorExifAgeBadge';
    const $existing = $card.find(`#${badgeId}`);


    const $badge = $existing.length ? $existing : $(`
        <div class="card-footer position-sticky bottom-0 pt-0">
            <div class="d-flex align-items-center justify-content-between"
                 id="${badgeId}"
                 style="top: 150px;">
              <div class="badge rounded-pill bg-info-subtle badge-validator-primary txt3 py-1 px-2 d-inline-flex align-items-center js-exif-age-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title=""
              >
                <i class="fa-regular fa-calendar me-2 opacity-50"></i>
                <span class="js-exif-age-title text-muted fw-medium txt1 me-2">Σ days: </span>
                <span class="js-exif-age-text fw-bold txt1"></span>
              </div>
              <small class="text-muted txt4 js-exif-age-subtext"></small>
            </div>
        </div>
    `);

    if (!$existing.length) {
        $card.append($badge);
    }

    const $tooltipTarget = $badge.find('.js-exif-age-tooltip').first();
    $tooltipTarget.attr('data-bs-title', `Σ Age: ${payload.coverage || ''}`);
    $tooltipTarget.attr('data-bs-original-title', `Σ Age: ${payload.coverage || ''}`);

    $badge.find('.js-exif-age-text').text(`${payload.coverage_days}`);
    $badge.find('.js-exif-age-subtext').text(payload.sublabel);

    const existingTooltip = bootstrap.Tooltip.getInstance($tooltipTarget[0]);
    if (existingTooltip) {
        existingTooltip.dispose();
    }
    new bootstrap.Tooltip($tooltipTarget[0]);
}

const updateValidatorExifAgeBadges = () => {
    $('.card').each(function () {
        const $card = $(this);

        const $table = $card.find('table.fb-element-dynamic-units').first();
        if ($table.length === 0) return;

        const seenIso = new Set();
        const dates = [];
        let imageCount = 0

        $table.find('.js-countable-fb-element tr').each(function () {
            if (!$(this).length) return;

            const exifText = $(this).find('.media-creation-date').first().text();
            if (!exifText) return;

            const iso = extractIsoDateFromText(exifText);
            if (!iso) return;

            if (seenIso.has(iso)) return;
            seenIso.add(iso);

            const d = new Date(iso);
            if (isNaN(d.getTime())) return;

            dates.push(d);
        });

        const imgToCount = $table.find('img.count-img-for-validator');
        if (imgToCount) {
            imageCount = imgToCount.length;
        }

        if (dates.length <= 1) {
            $card.find('#validatorExifAgeBadge').remove();
            return;
        }

        let earliestDate = dates[0];
        let latestDate = dates[0];

        for (let i = 1; i < dates.length; i++) {
            if (dates[i] < earliestDate) earliestDate = dates[i];
            if (dates[i] > latestDate) latestDate = dates[i];
        }

        const start = new Date(
            earliestDate.getFullYear(),
            earliestDate.getMonth(),
            earliestDate.getDate(),
            earliestDate.getHours (),
            earliestDate.getMinutes (),
            earliestDate.getSeconds ()
        );

        const end = new Date(
            latestDate.getFullYear(),
            latestDate.getMonth(),
            latestDate.getDate(),
            latestDate.getHours (),
            latestDate.getMinutes (),
            latestDate.getSeconds ()
        );

        const coverageDays = (end - start) / (1000 * 60 * 60 * 24);

        let props = {
            coverage_days: `${formatDurationFromDays(coverageDays, ['d'])}`,
            coverage: `${formatDurationFromDays(coverageDays, ['y','m','d','h'])}`
        }

        if (imageCount > 0) {
            props.sublabel = `Total ${imageCount} images (only ${dates.length} with EXIF date)` // • ${distinctDays} distinct calendar day(s)` }}
        }

        upsertValidatorExifAgeBadge($card, props);
    });
};

const initValidatorExifAgeListener = () => {
    if (window.__validatorExifAgeListenerInitialized) return;
    window.__validatorExifAgeListenerInitialized = true;

    const debouncedUpdate = debounceWhileSaving(function () {
        updateValidatorExifAgeBadges();
    }, 250);

    updateValidatorExifAgeBadges();

    const observer = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
            const m = mutations[i];
            if (m.type !== 'childList') continue;

            const nodes = [].concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []));
            for (let j = 0; j < nodes.length; j++) {
                const node = nodes[j];
                if (!node || node.nodeType !== 1) continue;

                if (
                    node.id === 'exif-info-wrapper' ||
                    node.classList.contains('image-exif-info-table') ||
                    (node.querySelector && (
                        node.querySelector('#exif-info-wrapper') ||
                        node.querySelector('.image-exif-info-table') ||
                        node.querySelector('table.fb-element-dynamic-units')
                    ))
                ) {
                    debouncedUpdate();
                    return;
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.fb-element-remove-button', () => { setTimeout(debouncedUpdate, 150); });
    $(document).on('change', 'input[type="file"]', () => { setTimeout(debouncedUpdate, 250); });
}


//-------------- isntructions.js:
const validatorShowHideDefinedInscrutions = (instructionVisibilityStatus) => {
    var $element = $('#can-be-hidden-by-vtb');

    if (instructionVisibilityStatus == 'shown') {
        $element.fadeIn();
    } else {
        $element.fadeOut();
    }
}

let validatorPlaybackSpeedObserver = null;

const normalizeValidatorPlaybackSpeed = (playbackSpeed) => {
    const parsedSpeed = parseFloat(playbackSpeed);
    return Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : 1;
}

const validatorPlaybackSpeedStorageKey = () => `${gon.user}_ValidatorPlaybackSpeed`;

const updateValidatorPlaybackSpeedIndicator = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    const isDefaultSpeed = normalizedSpeed === 1;
    const formattedSpeed = `${normalizedSpeed}x`;
    const playbackSpeedToggle = $('#playbackSpeedToggle');
    const tachometerIcon = playbackSpeedToggle.find('.fa-tachometer-alt');
    const speedBadge = playbackSpeedToggle.find('.validator-playback-speed-value');

    playbackSpeedToggle.toggleClass('validator-playback-speed-custom', !isDefaultSpeed);
    tachometerIcon.toggleClass('text-warning', !isDefaultSpeed);
    speedBadge.toggleClass('d-none', isDefaultSpeed).text(formattedSpeed);
    playbackSpeedToggle.find('> a').attr('aria-label', `Playback speed: ${formattedSpeed}`);
    tachometerIcon.attr({
        title: `Playback speed: ${formattedSpeed}`,
        'data-bs-original-title': `Playback speed: ${formattedSpeed}`,
        'data-bs-title': `Playback speed: ${formattedSpeed}`
    });

    $('#playbackSpeedControls li').removeClass('active');
    $('#playbackSpeedControls a').each(function (){
        if (parseFloat($(this).attr('data-feedback-speed')) === normalizedSpeed){
            $(this).closest('li').addClass('active');
        }
    });
}

const applyValidatorPlaybackSpeedToMedia = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    $('video, audio').each(function () {
        this.playbackRate = normalizedSpeed;
    });
}

const validatorPlaybackSpeed = (playbackSpeed) => {
    const normalizedSpeed = normalizeValidatorPlaybackSpeed(playbackSpeed);
    localStorage.setItem(validatorPlaybackSpeedStorageKey(), normalizedSpeed);
    applyValidatorPlaybackSpeedToMedia(normalizedSpeed);
    updateValidatorPlaybackSpeedIndicator(normalizedSpeed);
}

const applyStoredValidatorPlaybackSpeed = () => {
    const storedPlaybackSpeed = localStorage.getItem(validatorPlaybackSpeedStorageKey());
    const playbackSpeed = storedPlaybackSpeed != null ? storedPlaybackSpeed : 1;

    applyValidatorPlaybackSpeedToMedia(playbackSpeed);
    updateValidatorPlaybackSpeedIndicator(playbackSpeed);
}

const observeValidatorPlaybackSpeedMedia = () => {
    if (validatorPlaybackSpeedObserver || !document.body) return;

    validatorPlaybackSpeedObserver = new MutationObserver((mutations) => {
        const mediaInserted = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
            node.nodeType === Node.ELEMENT_NODE &&
            (
                node.matches?.('video, audio') ||
                node.querySelector?.('video, audio')
            )
        )));

        if (mediaInserted) applyStoredValidatorPlaybackSpeed();
    });

    validatorPlaybackSpeedObserver.observe(document.body, { childList: true, subtree: true });
}

const validatorImageSize = (imgSize) => {
    if (imgSize == 'reset') {
        localStorage.removeItem(gon.user + '_ValidatorImageSize');
        $('body label + div > *').each(function () {
            $('img').each(function () {
                $(this).removeAttr('style');
            });
        });
    } else {
        localStorage.setItem(gon.user + '_ValidatorImageSize', imgSize);
        $('body label + div > *').each(function () {
            $('img').each(function () {
                $(this).width(imgSize).height('auto');
            });
        });
    }
}


//-------------- validate_images_count_badge.js:
const updateValidatorImagesCountBadge = () => {
    const $header = $('#jobsInfoHeader');
    if ($header.length === 0) return;

    const count = $('.count-img-for-validator').length;

    let $validatorImagesCountBadge = $header.find('#validatorImagesCountBadge');
    if ($validatorImagesCountBadge.length === 0) {
        $validatorImagesCountBadge = $(`
            <div class="badge rounded-pill badge-validator-primary txt3 px-2 d-flex align-items-center justify-content-center"
                 id="validatorImagesCountBadge"
                 style="background-color:rgba(26, 150, 240, 0.2);"
                 data-bs-toggle="tooltip"
                 data-bs-placement="bottom"
                 data-bs-html="true"
                 title=""
             >
                <span class="validator-images-count-text fw-bold txt1 me-2">${count}</span>
                <i class="fa-regular fa-images" style="opacity:.3"></i>
            </div>
            <span class="text-dark">|</span>
        `);
        $header.prepend($validatorImagesCountBadge);
    }

    const lines = [];
    $('.js-countable-fb-element').each(function() {
        const $countable = $(this);
        const $formRow = $countable.closest('.form-row');
        let $label = $formRow.find('.element-label-anchor').first();
        if ($label.length === 0) return;

        const labelName = ($label.find('p').first().text() || $label.text() || '').trim();
        if (!labelName) return;

        const labelCounter = ($formRow.find('.js-label-counter').first().text() || '').trim();
        lines.push(`<div class="d-flex flex-row align-items-center justify-content-between txt4 w-100">${escapeHTML(labelName)} <strong class="ms-3">${escapeHTML(labelCounter)}</strong></div>`);
    });
    $validatorImagesCountBadge.find('.validator-images-count-text').text(count);

    const tooltipHtml = lines.length ? `<div class="d-flex flex-column row-gap-2">${lines.join('\n')}</div>` : null

    if (!tooltipHtml) return;
    $validatorImagesCountBadge.attr('data-bs-original-title', tooltipHtml).attr('title', tooltipHtml);

    const validatorImagesCountBadgeTooltip = $validatorImagesCountBadge[0]
    const existing = bootstrap.Tooltip.getInstance(validatorImagesCountBadgeTooltip);
    if (existing) existing.dispose();
    new bootstrap.Tooltip(validatorImagesCountBadgeTooltip)
}

const initValidatorImagesCountListener = () => {
    if (window.__validatorImagesCountListenerInitialized) return;
    window.__validatorImagesCountListenerInitialized = true;

    const debouncedImgCountUpdate = debounceWhileSaving(() => {
        updateValidatorImagesCountBadge();
    }, 200);

    updateValidatorImagesCountBadge();

    const observer = new MutationObserver( (mutations) => {
        for (let i = 0; i < mutations.length; i++) {
            const m = mutations[i];
            if (m.type === 'childList') {
                const nodes = [].concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []))
                for (let j = 0; j < nodes.length; j++) {
                    const node = nodes[j];
                    if (!node || node.nodeType !== 1) continue;

                    if ( node.classList.contains('validator-images-count-text') ||
                        (node.querySelector && node.querySelector('.validator-images-count-text')) ) {
                        debouncedImgCountUpdate();
                        return;
                    }
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.fb-element-remove-button', () => { setTimeout(debouncedImgCountUpdate, 100); });

    $(document).on('change', 'input[type="file"]', () => { setTimeout(debouncedImgCountUpdate, 200); });
}


const validatorShowHideInscrutions = (validatorInstructionsStatus) => {
    $(document).find('body .card:not(.always-shown-vtb)').each(function () {
        let card = $(this);
        let containsInputVideoAudio = card.find(':input, textarea, table video, audio').length > 0;
        let elementsAreHiddenForValidator = card.find('.hide-instructions-for-validator').length > 0;

        if (validatorInstructionsStatus == 'shown' || elementsAreHiddenForValidator) {
            card.find('.hide-instructions-for-validator').fadeIn().removeClass('hide-instructions-for-validator');

            card.show();

            $('.validatorShowHideInscrutions')
                .attr('title', I18n.t("validation_toolbox.hide_instruction"))
                .find('.far.fa-eye')
                .removeClass('far fa-eye')
                .addClass('fas fa-eye-slash')
                .end();
            document.querySelectorAll('.validatorShowHideInscrutions').forEach(function (tooltipElement) {
                let tooltipInstance = bootstrap.Tooltip.getInstance(tooltipElement);
                if (tooltipInstance) {
                    tooltipInstance.dispose();
                }
                new bootstrap.Tooltip(tooltipElement);
            });
        } else if (!containsInputVideoAudio) {
            card.find('img').not($('table img, img[src*="gif"]')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('img[src*="gif"]').fadeIn().removeClass('hide-instructions-for-validator');
            card.find('p').not($('table p, #can-be-hidden-by-vtb p, .can-be-pinned-by-validator p, p:has(img[src*=".gif"]), p:has(audio), p:has(video)')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('p ~ ul').not($('table ul, ul.playback-speed')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('ol').not($('table ol')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('h2').not($('table h2')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('video').not($('table video')).fadeOut().addClass('hide-instructions-for-validator');
            card.find('div#can-be-hidden-by-vtb').fadeOut().addClass('hide-instructions-for-validator');


            $.when(card.find(':animated').promise()).then(function() {
                let relevantChildren = card.find('.form-row > *');
                let visibleNonValidatorChildren = relevantChildren.filter(':visible').not('.hide-instructions-for-validator');

                card.find('.bg-light').addClass('test');
                if (visibleNonValidatorChildren.length === 0) {
                    card.hide();
                } else {
                    card.show();
                }
            });

            $('.validatorShowHideInscrutions')
                .attr('title', I18n.t("validation_toolbox.show_instruction"))
                .find('.fas.fa-eye-slash')
                .removeClass('fas fa-eye-slash')
                .addClass('far fa-eye')
                .end();
            document.querySelectorAll('.validatorShowHideInscrutions').forEach(function (tooltipElement) {
                let tooltipInstance = bootstrap.Tooltip.getInstance(tooltipElement);
                if (tooltipInstance) {
                    tooltipInstance.dispose();
                }
                new bootstrap.Tooltip(tooltipElement);
            });
        }

    });
}


function getCommentListForValidatorModal() {
    var storedLabels = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments'));
    if (storedLabels) {
        var $validatorCommentsModalList = $('<ul class="list-group">');
        $.each(storedLabels, function (index, value) {
            var $ModalCommentList = $('<li class="d-flex flex-row list-group-item justify-content-between align-items-center"></li>');
            var $ModalCommentLabel = $('<div class="label-text"  contenteditable="true"></div>').text(value);
            var $ModalDeleteCommentBtn = $('<a href="#" class="btn btn-sm delete-validation-comment rounded-circle border-0"><i class="far fa-trash-alt"></i></a>');

            $ModalCommentList.append($ModalCommentLabel).append($ModalDeleteCommentBtn);
            $validatorCommentsModalList.append($ModalCommentList);
        });
        $('#validatorToolboxModal .modal-body').empty();
        $('#validatorToolboxModal .modal-body').html($validatorCommentsModalList);

        var $addNewCommentBtn = $('<a href="#" class="btn btn-primary add-comment-btn">' + I18n.t('validation_toolbox.modal_addnewcomment') + '</a>');
        $('#validatorToolboxModal .modal-body').append($addNewCommentBtn);

        $addNewCommentBtn.on('click', function (e) {
            e.preventDefault();
            var $newCommentLi = $('<li class="d-flex flex-row list-group-item justify-content-between align-items-center"></li>');
            var $newCommentLabel = $('<div class="label-text" contenteditable="true"></div>');
            var $newDeleteCommentBtn = $('<a href="#" class="btn btn-sm delete-validation-comment rounded-circle border-0"><i class="far fa-trash-alt"></i></a>');
            $newCommentLi.append($newCommentLabel).append($newDeleteCommentBtn);
            $validatorCommentsModalList.append($newCommentLi).find('.label-text').focus();
        });
    }
    $('#validatorToolboxModal .modal-footer .modal-submit-button-wrapper').html('<a href="#" type="button" class="btn btn-primary" id="SavevalidatorToolboxModal" data-bs-dismiss="modal">' + I18n.t("validation_toolbox.modal_save") + '</a>');
}


function appendCommentListToValidationToolbox() {
    if (localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments') == null) {
        const now = new Date();
        const toolboxListCreationtimeStamp = formatDate(now);

        var labels = $('.validation-declination-reasons input[type="checkbox"]').siblings('label');
        var labelTexts = [];
        labels.each(function () {
            if ($(this).text() != null) {
                labelTexts.push($(this).text().trim());
            }
        });
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments', JSON.stringify(labelTexts));
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate', toolboxListCreationtimeStamp);
    }
    var storedLabels = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments'));
    if (storedLabels) {
        var $select = $('<select class="form-control selectpicker" id="validator_notAcceptedComments_dropdown" multiple data-live-search="true" data-width="100%" data-selected-text-format="count" title="'+ I18n.t("validation_toolbox.choose_a_comment") +'">');
        $.each(storedLabels, function (index, value) {
            $select.append($('<option>').text(value).val(value));
        });
        $('body #toolbox-validation-comments-selection').html($select);
        $('#validator_notAcceptedComments_dropdown.selectpicker').selectpicker();
    }
    $('#toolbox-validation-comments-selection .selectpicker').on('show.bs.select', function () {
        var currentScroll = $(window).scrollTop();
        $(window).one('scroll', function () {
            $(window).scrollTop(currentScroll);
        });
    });
    attachSelectpickerEventListener();
}

appendMainValidationToolSections = () => {
    const storedData = JSON.parse(localStorage.getItem(`${gon.user}_${node_config_id}_${job_task_id}_commentSectionsData`)) || {};
    const $allCommentBoxes = $('.validation-tool-comment-box');
    let mainIndex = 1;

    if ($allCommentBoxes.length === 0) return;

    const handledBoxes = new Set();

    $allCommentBoxes.each(function () {
        const $box = $(this);
        const commentMediaId = $(this).attr('data-media-id');
        const commentMedianame = $(this).attr('data-media-name');
        if (handledBoxes.has($box[0])) return;

        const $wrapper = $box.closest('table.fb-element-dynamic-units');
        const $groupBoxes = $wrapper.find('.validation-tool-comment-box');

        if ($wrapper.length && $groupBoxes.length > 1) {
            let subIndex = 1;

            $groupBoxes.each(function () {
                const $subBox = $(this);
                if (handledBoxes.has($subBox[0])) return;

                const commentBoxId = `${mainIndex}.${subIndex}`;
                handledBoxes.add($subBox[0]);

                renderValidationToolBox($subBox, commentBoxId, commentMediaId, commentMedianame, storedData, true, subIndex);
                subIndex++;
            });
            mainIndex++;
        } else {
            const commentBoxId = `${mainIndex}`;
            handledBoxes.add($box[0]);

            renderValidationToolBox($box, commentBoxId, commentMediaId, commentMedianame, storedData);
            mainIndex++;
        }
    });

    appendCommentListToValidationToolbox();
};

renderValidationToolBox = ($box, commentBoxId, commentMediaId, commentMediaName, storedData, isASubChild = false, subIndex = null) => {
    const $listOfComments = $('<ul class="ps-3 m-0"></ul>');
    const mediaIdentifier = commentMediaId || commentMediaName || commentBoxId

    if (storedData[mediaIdentifier]) {
        storedData[mediaIdentifier].forEach(comment => {
            $listOfComments.append($('<li>').text(comment));
        });
        $('#validator-comments-reminder').addClass('show');
    } else {
        $listOfComments.append($('<li>'));
    }

    const title = I18n.t("validation_toolbox.task_n_validation", { TaskNumber: commentBoxId });

    const $elementsToolboxHTMLContent = $('<div>').append(
        $('<p>').addClass('text-primary fw-light').text(title),
        $('<div>').addClass('row mb-3').append(
            $('<div>').addClass('col').attr('id', 'toolbox-validation-comments-selection')
        ),
        $('<div>').addClass('row').append(
            $('<div>').addClass('col').append(
                $('<div>')
                    .addClass('m-0 form-control bg-white border-0')
                    .attr('id', 'toolbox-element-validation-comments')
                    .attr('contenteditable', 'true')
                    .attr('data-comment-media-id', commentMediaId)
                    .attr('data-comment-media-name', commentMediaName)
                    .attr('data-comment-box-id', commentBoxId)
                    .attr('data-comment-box-subindex-id', subIndex)
                    .append(
                        $('<p>').text(`${isASubChild? subIndex + ') ' : ''}${$box.closest('.card-body').find('label:first').text()}:`),
                        $listOfComments
                    )
            )
        )
    );

    $box.html($elementsToolboxHTMLContent).attr('data-element-box-id', commentBoxId);
};

function resetMainValidationToolComment(){
    localStorage.removeItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments');
    appendCommentListToValidationToolbox();
    getCommentListForValidatorModal();

    $('#toolbox-validation-comments-selection.selectpicker').selectpicker();
    attachSelectpickerEventListener();
}

function attachSelectpickerEventListener() {
    $('#toolbox-validation-comments-selection .selectpicker').on('change.bs.select', function(e) {
        let commentMediaId = $(this).closest('.validation-tool-comment-box').attr('data-media-id');
        let commentMediaName = $(this).closest('.validation-tool-comment-box').attr('data-media-name');
        let commentBoxId = $(this).closest('.validation-tool-comment-box').attr('data-element-box-id');
        var $destinationTextArea = $(this).closest('.validation-tool-comment-box').find('#toolbox-element-validation-comments ul');
        var $selectedOptions = $(this).val() || [];
        let storageData = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData')) || {};
        const mediaIdentifier = commentMediaId || commentMediaName || commentBoxId;

        if (!Array.isArray(storageData[mediaIdentifier])) {
            storageData[mediaIdentifier] = [];
        }

        let newComments = $selectedOptions.filter(function(comment) {
            return !storageData[mediaIdentifier].includes(comment);
        });

        if (newComments.length > 0) {
            $destinationTextArea.find('li').filter(function() {
                return $(this).text().trim() === '';
            }).remove();
            newComments.forEach(function (comment) {
                var $commentItem = $('<li></li>').text(comment);
                $destinationTextArea.append($commentItem);
                storageData[mediaIdentifier].push(comment);
            });
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData', JSON.stringify(storageData));
            $('#validator-comments-reminder').addClass('show');
        }
    });
}


function appendMainValidationToolCollectCommentSections() {
    var collectCommentContainer = $('.validation-tool-comments-collect-box');
    var validatorInfoNotice = $(`
        <div class="alert alert-warning alert-dismissible fade" id="validator-comments-reminder" role="alert">
          <ul class="ps-3 mb-0"><li>Please ensure that you have inserted all your comments before submitting the job.</li></ul>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    `);
    if (collectCommentContainer && $('.validation-tool-comment-box').length > 0) {
        collectCommentContainer.html('<div class="row align-items-center">' +
            '<div class="col-auto">' +
            '<p class="text-primary fw-light m-0 lh-1">'+ I18n.t("validation_toolbox.collect_allValidation_1stline") +'<br>'+ I18n.t("validation_toolbox.collect_allValidation_2ndline") +'</p>' +
            '</div>' +
            '<div class="col-auto d-flex flex-row">' +
            '<a href="#" class="btn btn-primary collectAllValidationsToolboxComments">'+ I18n.t("validation_toolbox.add_to_my_final_comment") +'</a>' +
            '<a href="#" class="btn btn-outline-primary modalAllValidationsToolboxComments" data-bs-toggle="modal" data-bs-target="#validatorToolboxModal">'+ I18n.t("validation_toolbox.show_before_adding") +'</a>' +
            '</div>' +
            '</div>');
        collectCommentContainer.closest('.card-body').append(validatorInfoNotice);
    }

}


getAllCommentsForValidatorToTextarea = (dataSource) => {
    const $reviewDataJson = $('input[id*="_review_data"]');
    const $finalReviewerCommentTextarea = $('[id*="_review_comment"]');
    const $collectedRawCommentsContainer = $('#display_review_comment');

    const defaultText = $('#job_resubmission_check').is(':checked') ? I18n.t("validation_toolbox.thanks_text_comments_resubmission") : I18n.t("validation_toolbox.thanks_text_comments");
    const currentText = dataSource ? $('#ModalValidatorFinalCommentsTextarea').text() || defaultText : $finalReviewerCommentTextarea.val() || defaultText;

    let finalValidatorComment = "";
    let commentsMap = {};

    const $validationsComment = $('.validation-tool-comment-box #toolbox-element-validation-comments');
    const allValidations = [];
    let isFirstParagraph = true;

    $validationsComment.find('li').filter((_, li) => $(li).text().trim() === '').remove();

    $validationsComment.each(function () {
        const $box = $(this);
        const $liElements = $box.find('li');
        const $mainCommentsWrapper = $liElements.closest('#toolbox-element-validation-comments');
        const mediaSlug = $box.closest('.validation-tool-comment-box').attr('data-media-id');
        const mediaName = $box.closest('.validation-tool-comment-box').attr('data-media-name');
        const subindex = $mainCommentsWrapper.first().attr('data-comment-box-subindex-id');


        const liTexts = $liElements.map((_, li) => $(li).text().trim()).get().filter(Boolean);

        const $closestInput = $box.closest('.card-body').find('input[id]').first();
        const inputId = $closestInput.attr('id');

        if (inputId && liTexts.length > 0) {
            const normalizedId = inputId.replace(/^.*?_df_create_?/, '').replace(/_+$/, '');

            const elementSlug = normalizedId;
            const mediaKey = mediaSlug || mediaName || (subindex ? String(parseInt(subindex, 10) - 1) : '0');

            if (!commentsMap[elementSlug]) commentsMap[elementSlug] = { sub: {} };

            const commentsArray = Array.isArray(liTexts)
                ? liTexts
                : String(liTexts || '')
                    .split('\n')
                    .map(s => s.trim())
                    .filter(Boolean);

            commentsMap[elementSlug].sub[mediaKey] = commentsArray;
        }

        if ($liElements.length > 0) {
            $box.find('p, li').each(function () {
                const text = $(this).text().trim();
                if (!text) return;

                if ($(this).is('p')) {
                    allValidations.push((isFirstParagraph ? "" : "\n") + text + "\n");
                    isFirstParagraph = false;
                } else {
                    allValidations.push(text + "\n");
                }
            });
        }
    });

    finalValidatorComment = allValidations.join('');

    const isConfirmed = $finalReviewerCommentTextarea.val() !== null && $finalReviewerCommentTextarea.val().trim() !== ""
        ? confirm(I18n.t('validation_toolbox.prompt_collect_comments'))
        : true;

    if (!isConfirmed) return false;

    const commentsMapStr = JSON.stringify(commentsMap, null, 2);
    $reviewDataJson.val(commentsMapStr);
    $finalReviewerCommentTextarea
        .val(currentText)
        .attr('data-comments', finalValidatorComment)
        .height('auto');
    $collectedRawCommentsContainer.text(finalValidatorComment);

    const prefix = gon.user + '_' + node_config_id + '_' + job_task_id;
    localStorage.setItem(prefix + '_validator_CustomComments', currentText);
    localStorage.setItem(prefix + '_validator_allComments_plain', finalValidatorComment);
    localStorage.setItem(prefix + '_validator_allComments_json', commentsMapStr);
}


function getAllCommentsForValidatorModal() {
    var $finalReviewerModalTextarea = $('<div id="ModalValidatorFinalCommentsTextarea" class="form-control h-auto" contenteditable="true"></div>');
    var $finalReviewerModalNonEditableComment = $('<div id="ModalValidatorFinalCollectedComments" class="form-control h-auto"></div>');
    var $validationsComment = $('.validation-tool-comment-box #toolbox-element-validation-comments');
    var allValidations = [];
    var isFirstParagraph = true;
    var $finalReviewerCommentTextareaValue = $('[id*="_review_comment"]').val();

    $validationsComment.find('li').filter(function() {
        return $(this).text().trim() === '';
    }).remove();
    $validationsComment.each(function () {
        if ($(this).find('li').length > 0) {
            var $commentBox = $(this);
            $commentBox.find('p, li').each(function () {
                var $element = $(this);
                var commentText = $element.text().trim();
                if (commentText) {
                    if ($element.is('p')) {
                        if (isFirstParagraph) {
                            allValidations.push(commentText + '\n');
                            isFirstParagraph = false;
                        } else {
                            allValidations.push('\n' + commentText + '\n');
                        }
                    } else if ($element.is('li')) {
                        allValidations.push(commentText + '\n');
                    }
                }
            });
        }
    });
    var finalValidatorComment = allValidations.join('');
    $('#validatorToolboxModal #manage-validation-comment').html($finalReviewerModalTextarea.html($finalReviewerCommentTextareaValue).attr('data-comments', finalValidatorComment))
    if (finalValidatorComment.length) {
        $('#validatorToolboxModal #manage-validation-comment').append($finalReviewerModalNonEditableComment.html(finalValidatorComment));
    } else {
        $('#ModalValidatorFinalCollectedComments').empty();
    }
    $('#validatorToolboxModal .modal-footer .modal-submit-button-wrapper').html('<a href="#" type="button" class="btn btn-primary collectAllValidationsToolboxComments" data-bs-dismiss="modal">'+ I18n.t("validation_toolbox.add_to_my_final_comment") +'</a>');
}


function appendPinnedContent(text, pinnedId) {
    var prefix = pinnedId.includes('age') ? "Age: " : pinnedId.includes('countryCode') ? 'Country Code: ' :  pinnedId.includes('openTaskNbr') ? 'Open Jobs: ' :'';
    var spanHtml = `<div class="badge rounded-pill badge-validator-primary validator-pinned-infos txt4" data-badge-pinned="${pinnedId}">
                        <span contenteditable="true">${prefix}${text}</span>
                        <a href="#" class="remove-pinned-info">
                            <i class="fas fa-times"></i>
                        </a>
                    </div>`;
    $('#jobsInfoHeader').append(spanHtml);
}


$(document).on('load turbolinks:load', function() {
    if (!window.node_config_id) return;

    $(document).find('body').addClass('validation-job');
    $(document).on('click', '#playbackSpeedControls a', function (e) {
        let playbackSpeed = $(this).attr('data-feedback-speed');
        validatorPlaybackSpeed(playbackSpeed);
        $(this).closest('ul').find('.list-inline-item').removeClass('active');
        $(this).closest('.list-inline-item').addClass('active');
        e.preventDefault();
    });

    $(document).on('click', '#imagesSizeControls a', function (e) {
        e.preventDefault();
        let imgSize = $(this).data('images-size');
        validatorImageSize(imgSize);
        $(this).closest('ul').find('.list-inline-item').removeClass('active');
        $(this).closest('.list-inline-item').addClass('active');
    });

    $(document).on('click', '#validatorCommentModalButton', function (e) {
        getCommentListForValidatorModal();
    });

    $(document).on('click', '.modalAllValidationsToolboxComments', function (e) {
        e.preventDefault();
        getAllCommentsForValidatorModal();
    });

    $(document).on('click', '.collectAllValidationsToolboxComments', function (e) {
        e.preventDefault();
        if ($(this).attr('data-bs-dismiss')) {
            getAllCommentsForValidatorToTextarea('forModal');
        } else {
            getAllCommentsForValidatorToTextarea();
        }
    });

    $(document).on('mouseover', '#playbackSpeedToggle', function(e) {
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")) {
            dropdownMenu.parent().toggleClass("open");
        }
    });

    $(document).on('click', '.delete-validation-comment', function(e) {
        e.preventDefault();
        $(this).closest('li').remove();
    });


    attachSelectpickerEventListener()
    observeValidatorPlaybackSpeedMedia();
    applyStoredValidatorPlaybackSpeed();

    if ($('.validation-tool-comment-box').length == 0){
        $('.for-validatorCommentModalButton').hide();
    }

    if(localStorage.getItem(gon.user+'_ValidatorImageSize')!=undefined){
        validatorImageSize(localStorage.getItem(gon.user+'_ValidatorImageSize'));
        $('#imagesSizeControls li').removeClass('active');
        $('#imagesSizeControls a').each(function (){
            if ($(this).attr('data-images-size') == localStorage.getItem(gon.user+'_ValidatorImageSize')){
                $(this).closest('li').addClass('active');
            }
        });
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_json') != null && ($('input[id*="_review_data"]').length)) {
        var validator_allComments_json = localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_json')
        $('input[id*="_review_data"]').val(validator_allComments_json);
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_plain') != null && $('textarea[id*="_review_comment"]').length) {
        var validator_allComments_plain = localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_allComments_plain')
        $('textarea[id*="_review_comment"]').attr('data-comments', validator_allComments_plain);
        $('#display_review_comment').text(validator_allComments_plain);
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments') != null && ($('textarea[id*="_review_comment"]').length || $('#ModalValidatorFinalCommentsTextarea').length)) {
        $('textarea[id*="_review_comment"]').val(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments')).height('auto');
    }

    if ($('textarea[id*="_review_comment"]').length) {
        var saveFinalCommentToLocalStorage = debounceWhileSaving(function () {
            var textarea = $(this);
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_validator_CustomComments', textarea.val());
        }, 1000);

        $('textarea[id*="_review_comment"]').on('keydown', saveFinalCommentToLocalStorage)
    }

    if (localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content')) {
        var pinnedContentText, pinnedId = ""
        var pinnedContents = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content').split(';');
        pinnedContents.forEach(function(pinnedContent) {
            if (pinnedContent.includes('dynamic_')){
                pinnedContentText = $(`.can-be-pinned-by-validator[data-to-pinn="${pinnedContent}"]`).text().trim();
                pinnedId = pinnedContent;
            } else {
                pinnedContentText = pinnedContent;
            }
            if (pinnedContentText.trim() !== '') {
                appendPinnedContent(pinnedContentText, pinnedId);
            }
        });
    }

    if (localStorage.getItem(gon.user+'_validator-toolbox') != null && localStorage.getItem(gon.user+'_validator-toolbox') == 'hidden'){
        hideValidatorToolbox('hidden');
    }

    $('.can-be-pinned-by-validator').each(function () {
        var $this = $(this);
        var dataToPinn = $this.attr('data-to-pinn');
        if ($this.find('.pin-to-jobsInfoHeader').length == 0) {
            var localStorageData = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content');
            var showBtnStatus = "";
            if (localStorageData != null && localStorageData.includes(dataToPinn)) {
                showBtnStatus = "display: none";
            }
            var $buttonHtml = `<a href="#" role="button" class="btn btn-sm btn-primary pin-to-jobsInfoHeader rounded-circle my-0" style="${showBtnStatus}"><i class="fas fa-plus"></i></a>`;
            $this.append($buttonHtml);
        }
    });

    $(document).find('.card:not(.always-shown-vtb)').each(function(){
        if (!$(this).hasClass('bg-light') && !$(this).hasClass('validation-card-wrapper') && ($(this).find('.form-row').children().length <= 0)){
            $(this).addClass('d-none');
        }
    })

    initValidatorImagesCountListener();
    initValidatorExifAgeListener();


    if (window.batch_config_updated_at) {
        var shouldShowModal = false;
        var lastUpdate = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate');
        var notAcceptedComments = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_notAcceptedComments');

        if ((lastUpdate == null && notAcceptedComments != null) ||
            (lastUpdate != null && new Date(window.batch_config_updated_at) > new Date(lastUpdate))) {
            $('#resetCommentList').removeClass('d-none');
            $('a#validatorCommentModalButton').append('<span class="badge-pulse"><small></small></span>');

            new Noty({
                type: 'error',
                layout: 'topRight',
                theme: 'bootstrap-v4',
                text: '<div class="row">'+
                        '<div class="col">'+
                            '<strong class="txt2">' +
                                '<i class="fas fa-exclamation-triangle"></i> ' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert_title") +
                            '</strong>' +
                            '<p class="txt2 my-2 text-white">' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert") +
                            '</p>' +
                            '<a href="#" class="btn btn-light text-danger mx-0">' +
                                I18n.t("validation_toolbox.reset_validation_comment_alert_btn") +
                            '</a>' +
                        '</div>'+
                    '</div>',
                animation: {
                    open : 'animated fadeInRight',
                    close: 'animated fadeOutRight'
                },
            }).on('onClick', function () {
                getCommentListForValidatorModal();
                new bootstrap.Modal('#validatorToolboxModal').show();
            }).show();
        } else {
            $('#resetCommentList').remove();
        }

    } else {
        $('#resetCommentList').remove();
    }

    if (window.node_config_id) {
        if (localStorage.getItem(gon.user + '_' + node_config_id + '_validator_instructions') != null) {
            var validatorInstructionsStatus = localStorage.getItem(gon.user + '_' + node_config_id + '_validator_instructions')
            validatorShowHideDefinedInscrutions(validatorInstructionsStatus);
            validatorShowHideInscrutions(validatorInstructionsStatus);
        }

        var saveElementValidationCommentToLocalStorage = debounceWhileSaving(function (dataToStore) {
            localStorage.setItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData', JSON.stringify(dataToStore));
        }, 1000); // 1000ms between each change
    }

    $('#validatorToolboxModal').on('hidden.bs.modal', function () {
        $(this).find('.modal-body').empty();
    });

    $(document).on('click', '#resetCommentList', function (e) {
        $(this).addClass('d-none');
        // $(this).tooltip('hide');
        $(this).fadeOut('fast', function() {
            resetMainValidationToolComment();
            $(this).remove();
            $(document).find('a#validatorCommentModalButton .badge-pulse').remove();
        });
    });

    $(document).on('click', '.hide-validator-toolbox', function (e) {
        e.preventDefault();
        hideValidatorToolbox();
    });

    $(document).on('click', '#toggle-validation-comment-box', function (e) {
        e.preventDefault();
        $('.validation-tool-comment-box').toggleClass('d-none');
        $('.validation-tool-comments-collect-box').toggleClass('d-none');
        $(this).find('.form-check-input').toggleClass('checked').prop('checked', function(_, val) {
            return !val;
        });
    });

    $(document).on('click', '.validatorShowHideInscrutions', function (e) {
        e.preventDefault();
        let validatorInstructionsStatus = $("body").find('.hide-instructions-for-validator').length > 0 ? 'shown' : 'hidden'
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_instructions', validatorInstructionsStatus);
        validatorShowHideDefinedInscrutions(validatorInstructionsStatus);
        validatorShowHideInscrutions(validatorInstructionsStatus);
    });

    $(document).on('click', '.pin-to-jobsInfoHeader', function(e) {
        e.preventDefault();
        var parentText = $(this).closest('.can-be-pinned-by-validator').text().trim();
        var pinnedElementId = $(this).closest('.can-be-pinned-by-validator').attr('data-to-pinn');
        appendPinnedContent(parentText, pinnedElementId);
        var existingPinnedContent = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content');
        if (existingPinnedContent) {
            existingPinnedContent += pinnedElementId + ';';
        } else {
            existingPinnedContent = pinnedElementId + ';';
        }
        $(this).fadeOut(100);
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', existingPinnedContent);
    });


    $(document).on('keyup', '#toolbox-element-validation-comments', function(e) {
        let commentMediaId = $(this).closest('.validation-tool-comment-box').attr('data-media-id');
        let commentMediaName = $(this).closest('.validation-tool-comment-box').attr('data-media-name');
        let commentBoxId = $(this).closest('.validation-tool-comment-box').attr('data-element-box-id');
        let commentMediaIdentifier = commentMediaId || commentMediaName || commentBoxId;
        let $commentList = $(this).find('ul');
        let storedData = JSON.parse(localStorage.getItem(gon.user + '_' + node_config_id + '_' + job_task_id + '_commentSectionsData')) || {};
        let validationElementsComments = [];
        $commentList.find('li').each(function () {
            var commentText = $(this).text().trim();
            if (commentText !== '') {
                validationElementsComments.push(commentText);
            }
        });
        storedData[commentMediaIdentifier] = validationElementsComments;
        saveElementValidationCommentToLocalStorage(storedData);
    });

    $(document).on('keyup', '#toolbox-element-validation-comments', function(e) {
        let $commentBox = $(this);
        let $commentList = $commentBox.find('ul');
        let subIndexid = $(this).attr('data-comment-box-subindex-id');
        let counter = subIndexid ? `${subIndexid}) ` : '';

        if ($commentList.length === 0 || $commentList.find('li').length === 0) {
            $commentBox.append('<ul class="ps-3 m-0"><li></li></ul>');
        }
        if ($commentBox.find('p').text().trim() === "") {
            $commentBox.find('p').html(`${counter}${$commentBox.closest('.card-body').find('label:first').text() + ':'}`);
        }
        if ($commentBox.find('p').length === 0) {
            $commentBox.prepend(`<p><strong>${counter}${$commentBox.closest('.card-body').find('label:first').text()}:</strong></p>`);
        }
    });

    $(document).on('paste', '.validator-pinned-infos span[contenteditable]', function(e) {
        var pastedText = '';
        if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
            pastedText = e.originalEvent.clipboardData.getData('text/plain');
        } else if (window.clipboardData && window.clipboardData.getData) {
            pastedText = window.clipboardData.getData('text/plain');
        }
        document.execCommand('insertText', false, pastedText);
    });

    $(document).on('blur', '.validator-pinned-infos span[contenteditable]', function() {
        var updateIsDone = false;
        var updatedPinnedContent = "";
        var currentPinnedContent = localStorage.getItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
        var updatedPinnedId = $(this).closest('.validator-pinned-infos').addClass('with-updated-text').attr('data-badge-pinned');
        if (currentPinnedContent.length > 0) {
            var contentPinnedArray = currentPinnedContent.split(';');
            for (var i = 0; i < contentPinnedArray.length; i++) {
                if (contentPinnedArray[i].includes(updatedPinnedId) && !updateIsDone) {
                    contentPinnedArray[i] = $(this).text().trim();
                    updateIsDone = true;
                }
            }
            updatedPinnedContent = contentPinnedArray.join(';');
        }
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
    });

    $(document).on('click', '.remove-pinned-info', function(e) {
        var badgePinned = $(this).closest('.badge').attr("data-badge-pinned");
        $(document).find('.can-be-pinned-by-validator[data-to-pinn="' + badgePinned + '"]').find('.pin-to-jobsInfoHeader').fadeIn(300);
        e.preventDefault();
        $(this).closest('.badge').remove();
        var updatedPinnedContent = "";
        $('.validator-pinned-infos').each(function() {
            if ($(this).hasClass('with-updated-text')){
                updatedPinnedContent += $(this).find('span[contenteditable]').text().trim() + ';';
            } else {
                updatedPinnedContent += $(this).attr('data-badge-pinned') + ';';
            }
        });
        localStorage.setItem(gon.user + '_' + node_config_id + '_pinned_content', updatedPinnedContent);
    });

    $(document).on('click', '#SavevalidatorToolboxModal', function(e) {
        e.preventDefault();
        var commentList = $('#validatorToolboxModal .modal-body#manage-validation-comment .list-group-item');
        var commentListToSave = [];
        commentList.each(function() {
            if ($(this).find('.label-text').text().trim() != "") {
                commentListToSave.push($(this).find('.label-text').text().trim());
            }
        });
        localStorage.setItem(gon.user+'_'+ node_config_id +'_validator_notAcceptedComments', JSON.stringify(commentListToSave));
        appendCommentListToValidationToolbox();
        attachSelectpickerEventListener();
        localStorage.setItem(gon.user + '_' + node_config_id + '_validator_comments_lastUpdate', formatDate(new Date()));
    });
    if (window.node_config_id) {
        appendMainValidationToolCollectCommentSections();
        appendMainValidationToolSections();
    }

    $(document).on('submit', 'form#edit_job', function (e) {
        const $textarea = $('textarea[id*="_review_comment"]');
        const raw = $textarea.attr('data-comments');
        const dataComments = raw ? String(raw).trim() : '';
        const currentValue = ($textarea.val() || '').trim();
        if ($textarea.length && dataComments && !currentValue.includes(dataComments)) {
            $textarea.val((currentValue + '\n\n' + dataComments).trim());
        }
    });
});
